import { isValidVec3 } from '../utils/numbers.js'

export function createOrbitPersistence({ camera, controls, initialOrbitSettings, onSaveSettings }) {
  let saveTimer = null
  let settingsReady = false
  let lastSavedSettings = initialOrbitSettings

  function getOrbitSettings() {
    return {
      position: camera.position.toArray(),
      target: controls.target.toArray(),
      zoom: camera.zoom
    }
  }

  function getPersistedOrbitSettings() {
    return settingsReady ? getOrbitSettings() : lastSavedSettings
  }

  function applyOrbitSettings(orbitSettings) {
    if (!orbitSettings || !isValidVec3(orbitSettings.position) || !isValidVec3(orbitSettings.target)) {
      return false
    }

    camera.position.fromArray(orbitSettings.position)
    controls.target.fromArray(orbitSettings.target)
    if (Number.isFinite(orbitSettings.zoom)) {
      camera.zoom = orbitSettings.zoom
      camera.updateProjectionMatrix()
    }
    controls.update()
    return true
  }

  function scheduleSave() {
    if (!settingsReady) {
      return
    }

    clearTimeout(saveTimer)
    saveTimer = setTimeout(() => {
      lastSavedSettings = getOrbitSettings()
      onSaveSettings()
    }, 150)
  }

  function markReady() {
    settingsReady = true
    lastSavedSettings = getOrbitSettings()
  }

  controls.addEventListener('change', scheduleSave)

  return {
    applyOrbitSettings,
    getPersistedOrbitSettings,
    markReady
  }
}
